import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

type ReservationStatus = 'returned' | 'on-loan' | 'borrowed'

interface BookReservationItemProps {
  title: string
  thumbnailUrl: string | null
  author: string
  status?: ReservationStatus
  lastAction: string
  action?: ReactNode
  className?: string
}

const statusStyles: Record<ReservationStatus, string> = {
  returned: 'bg-emerald-100 text-emerald-800',
  'on-loan': 'bg-amber-100 text-amber-800',
  borrowed: 'bg-sky-100 text-sky-800',
}

const statusLabels: Record<ReservationStatus, string> = {
  returned: 'Returned',
  'on-loan': 'On loan',
  borrowed: 'Borrowed',
}

export const BookReservationItem = ({
  title,
  thumbnailUrl,
  author,
  status,
  lastAction,
  action,
  className,
}: BookReservationItemProps) => {
  return (
    <div className={cn('rounded-md border p-3', className)}>
      <div className='flex gap-3'>
        <div className='flex h-20 w-14 shrink-0 items-center justify-center overflow-hidden rounded-sm border bg-muted'>
          {thumbnailUrl ? (
            <img src={thumbnailUrl} alt={`Cover for ${title}`} className='h-full w-full object-cover' loading='lazy' />
          ) : (
            <span className='px-1 text-center text-[10px] text-muted-foreground'>No cover</span>
          )}
        </div>

        <div className='min-w-0 flex-1'>
          <p className='truncate font-medium'>{title}</p>
          <p className='truncate text-sm text-muted-foreground'>{author}</p>
          <p className='text-xs text-muted-foreground'>{lastAction}</p>
          {status && (
            <div className='mt-1 flex justify-end'>
              <span
                className={cn(
                  'inline-flex rounded-full px-2 py-0.5 text-xs font-medium',
                  statusStyles[status],
                )}
              >
                {statusLabels[status]}
              </span>
            </div>
          )}
        </div>
      </div>
      {action && <div className='pt-2'>{action}</div>}
    </div>
  )
}